module.exports = __webpack_public_path__ + "static/media/zxJy@4x.da5654b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zxJy@4x.png
// module id = 1890
// module chunks = 0 1